export const userDumyData = [
  {
    name: "Lorem",
    email: "LoremIpsum1@gmail.com",
    userName: "Lorem1",
    role: ["Admin", "Instructor"],
    license: true,
    status: true,
    expiration: "MM/DD/YYYY",
  },
  {
    name: "Ipsum",
    email: "Ipsum2@gmail.com",
    userName: "Lorem2",
    role: ["Admin"],
    license: false,
    status: true,
    expiration: "MM/DD/YYYY",
  },
  {
    name: "3",
    email: "3@hotmail.com",
    userName: "Lorem3",
    role: ["Instructor"],
    license: true,
    status: false,
    expiration: "MM/DD/YYYY",
  },
  {
    name: "Sukrit",
    email: "sukrit@gmail.com",
    userName: "Lorem4",
    role: ["Instructor"],
    license: false,
    status: false,
    expiration: "MM/DD/YYYY",
  },
  {
    name: "Awesome guy",
    email: "awe@gmail.com",
    userName: "Lorem5",
    role: ["Admin", "Instructor"],
    license: true,
    status: true,
    expiration: "MM/DD/YYYY",
  },
  {
    name: "Awesome",
    email: "sukrit@gmail.com",
    userName: "Lorem5",
    role: ["Admin", "Instructor"],
    license: true,
    status: true,
    expiration: "MM/DD/YYYY",
  },
];

export const orgDumyData = [
  {
    name: "Org 1",
    orgID: "123",
  },
  {
    name: "Org 2",
    orgID: "987",
  },
];

export const invoiceData = [
  {
    no: "inv-000454",
    license: "2-Month Academic",
    project: "GetVirtual+fall-20",
    status: "Paid",
    available: 2,
    total: 12,
    date: "MM/DD/YYYY"
  },
  {
    no: "inv-000454",
    license: "3-Month Academic",
    project: "GetVirtual+fall-20",
    status: "Paid",
    available: 9,
    total: 73,
    date: "MM/DD/YYYY"
  },
  {
    no: "inv-000456",
    license: "1-Month Academic",
    project: "GetVirtual+fall-20",
    status: "Paid",
    available: 9,
    total: 168,
    date: "MM/DD/YYYY"
  },
  {
    no: "inv-000454",
    license: "6-Month Professional",
    project: "GetVirtual+spring-21",
    status: "Unpaid",
    available: 5,
    total: 50,
    date: "MM/DD/YYYY"
  },
  {
    no: "inv-000458",
    license: "12-Month Enterprise",
    project: "GetVirtual+spring-21",
    status: "Paid",
    available: 15,
    total: 200,
    date: "MM/DD/YYYY"
  },
  {
    no: "inv-000454",
    license: "1-Month Trial",
    project: "GetVirtual+summer-21",
    status: "Pending",
    available: 0,
    total: 10,
    date: "MM/DD/YYYY"
  },
  {
    no: "inv-000454",
    license: "3-Month Trial",
    project: "GetVirtual+summer-21",
    status: "Unpaid",
    available: 3,
    total: 20,
    date: "MM/DD/YYYY"
  },
  {
    no: "inv-000454",
    license: "12-Month Academic",
    project: "GetVirtual+fall-21",
    status: "Paid",
    available: 12,
    total: 120,
    date: "MM/DD/YYYY"
  }
];


export const  InviteManagementData= [
  {
    "cohort": "Cohort A",
    "session": "Session 1",
    "status": "Completed",
    "created": "2024-09-01",
    "users": [
      {
        "name": "Alice",
        "email": "alice@example.com",
        "status": "Active",
        "group": "Group 1",
        "action": "Reviewed"
      },
      {
        "name": "Bob",
        "email": "bob@example.com",
        "status": "Inactive",
        "group": "Group 2",
        "action": "Pending"
      },
      {
        "name": "Carol",
        "email": "carol@example.com",
        "status": "Active",
        "group": "Group 1",
        "action": "Reviewed"
      }
    ]
  },
  {
    "cohort": "Cohort B",
    "session": "Session 2",
    "status": "In Progress",
    "created": "2024-09-05",
    "users": [
      {
        "name": "Charlie",
        "email": "charlie@example.com",
        "status": "Active",
        "group": "Group 1",
        "action": "Reviewed"
      },
      {
        "name": "Diana",
        "email": "diana@example.com",
        "status": "Active",
        "group": "Group 2",
        "action": "Pending"
      },
      {
        "name": "Eve",
        "email": "eve@example.com",
        "status": "Inactive",
        "group": "Group 3",
        "action": "Not Started"
      }
    ]
  },
  {
    "cohort": "Cohort C",
    "session": "Session 3",
    "status": "Scheduled",
    "created": "2024-09-10",
    "users": [
      {
        "name": "Frank",
        "email": "frank@example.com",
        "status": "Inactive",
        "group": "Group 4",
        "action": "Not Started"
      },
      {
        "name": "Grace",
        "email": "grace@example.com",
        "status": "Active",
        "group": "Group 5",
        "action": "Reviewed"
      },
      {
        "name": "Hannah",
        "email": "hannah@example.com",
        "status": "Active",
        "group": "Group 6",
        "action": "Pending"
      }
    ]
  }
]

export const viewSettingsModalData = [
  {
    policy: "Are presentation team member accessible ?",
  },
  {
    policy: "Are presentation team member accessible ?",
  },
  {
    policy: "Are presentation team member accessible ?",
  },
  {
    policy: "Are presentation team member accessible ?",
  },
  {
    policy: "Are presentation team member accessible ?",
  },
  {
    policy: "Are presentation team member accessible ?",
  },
]

export const cohortPeriodsModalData = [
  {
    date: 'MM/DD/YYYY',
    interview: 10,
  },
  {
    date: 'MM/DD/YYYY',
    interview: 10,
  },
  {
    date: 'MM/DD/YYYY',
    interview: 10,
  },
  {
    date: 'MM/DD/YYYY',
    interview: 10,
  },
  {
    date: 'MM/DD/YYYY',
    interview: 10,
  },
  {
    date: 'MM/DD/YYYY',
    interview: 10,
  },
]

export const scoringQuestionData = [
  {
    question: "Are presentation team member accessible ?",
  },
  {
    question: "Are presentation team member accessible ?",
  },
  {
    question: "Are presentation team member accessible ?",
  },
  {
    question: "Are presentation team member accessible ?",
  },
  {
    question: "Are presentation team member accessible ?",
  },
  {
    question: "Are presentation team member accessible ?",
  },
]

export const videoLibraryData = [
  {
    title: "What is Customer Discovery?",
    url: "https://www.youtube.com/watch?v=3glETaSe1-E",
  },
  {
    title: "Creating Hypotheses for Startups",
    url: "https://www.youtube.com/watch?v=_y3SjmApZ_E",
  },
  {
    title: "Customer Discovery Process Explained",
    url: "https://www.youtube.com/watch?v=BmK1iMPr9fg",
  },
  {
    title: "How to Validate a Business Hypothesis",
    url: "https://www.youtube.com/watch?v=PbEwkQeocv0",
  },
  {
    title: "Lean Startup - Customer Discovery",
    url: "https://www.youtube.com/watch?v=QcrIwUEC-yw",
  },
];

export const cohortUserDetailsData = [
  {
    name: "John Smith",
    email: "john.smith@example.com",
    username: "john_smith",
    invite: "Pending",
    role: "Admin",
    team: "Development",
    expiration: "2024-12-31",
  },
  {
    name: "Emily Johnson",
    email: "emily.johnson@example.com",
    username: "emily_j",
    invite: "Accepted",
    role: "User",
    team: "Marketing",
    expiration: "2024-10-15",
  },
  {
    name: "Michael Brown",
    email: "michael.brown@example.com",
    username: "mike_brown",
    invite: "Pending",
    role: "Moderator",
    team: "Sales",
    expiration: "2025-01-20",
  },
  {
    name: "Sarah Williams",
    email: "sarah.williams@example.com",
    username: "sarahW",
    invite: "Rejected",
    role: "Viewer",
    team: "Support",
    expiration: "2024-09-30",
  },
  {
    name: "David Miller",
    email: "david.miller@example.com",
    username: "daveMiller",
    invite: "Accepted",
    role: "User",
    team: "Finance",
    expiration: "2024-11-05",
  },
];

export const assignLicenseModalData = [
  {
    invoiceNo: "INV 3023",
    license: "1 Year Academic",
    project: "Lorem Ipsum",
    total: "04",
    remaining: "01",
  },
  {
    invoiceNo: "INV 3023",
    license: "3 Month Academic",
    project: "Lorem Ipsum",
    total: "04",
    remaining: "01",
  },
  {
    invoiceNo: "INV 3025",
    license: "3 Month Academic",
    project: "Lorem Ipsum",
    total: "04",
    remaining: "01",
  },
];
export const userDetailsArray = [
  {
    id: "1",
    organization: "Lorem Ipsum",
    cohort: "Lorem winter 123",
    team: "Lorem",
    role: "Team Member",
    license: [
      {
        product: "1 Year Academic",
        start: "MM/DD/YYYY",
        expiration: "MM/DD/YYYY (XX days)",
        invoice: "INV-12341234134134",
        status: "Active",
      },
      {
        product: "2 Year Academic",
        start: "MM/DD/YYYY",
        expiration: "MM/DD/YYYY (XX days ago)",
        invoice: "INV-12341234134134",
        status: "Expired",
      },
    ],
    details: [
      {
        id: "1",
        organization: "Lorem Ipsum",
        cohort: "Lorem winter 123",
        team: "Lorem",
        role: "Team Member",
      },
    ],
  },
  {
    id: "2",
    organization: "USC",
    cohort: "ANANA",
    team: "Lorem",
    role: "Team Member",
    license: [
      {
        product: "RRR 123",
        start: "MM/DD/YYYY",
        expiration: "MM/DD/YYYY",
        invoice: "INV-002",
        status: "Expired",
      },
      {
        product: "YYZ 123",
        start: "MM/DD/YYYY",
        expiration: "MM/DD/YYYY",
        invoice: "INV-003",
        status: "Active",
      },
    ],
    details: [
      {
        id: "2",
        organization: "USC",
        cohort: "ANANA",
        team: "Lorem",
        role: "Team Member",
      },
      {
        id: "3",
        organization: "USC",
        cohort: "ANANA",
        team: "Lorem",
        role: "Admin",
      },
      {
        id: "4",
        organization: "USC",
        cohort: "ANANA",
        team: "Lorem",
        role: "Instructor",
      },
    ],
  },
  {
    id: "3",
    organization: "Gamma Innovations",
    cohort: "Cohort E",
    team: "Team Epsilon",
    role: "Product Manager",
    license: [
      {
        product: "Software X",
        start: "2023-01-15",
        expiration: "2024-01-15",
        invoice: "INV-004",
        status: "Active",
      },
    ],
    details: [
      {
        id: "5",
        organization: "Gamma Innovations",
        cohort: "Cohort E",
        team: "Team Epsilon",
        role: "Product Manager",
      },
    ],
  },
  {
    id: "4",
    organization: "Alpha Corp",
    cohort: "Cohort C",
    team: "Team Gamma",
    role: "Developer",
    license: [
      {
        product: "Software Y",
        start: "2022-06-10",
        expiration: "2023-06-10",
        invoice: "INV-005",
        status: "Expired",
      },
    ],
    details: [
      {
        id: "6",
        organization: "Alpha Corp",
        cohort: "Cohort C",
        team: "Team Gamma",
        role: "Developer",
      },
    ],
  },
  {
    id: "5",
    organization: "Next Gen",
    cohort: "Cohort H",
    team: "Team Theta",
    role: "UI/UX Designer",
    license: [
      {
        product: "Software Z",
        start: "2023-10-10",
        expiration: "2024-10-10",
        invoice: "INV-006",
        status: "Active",
      },
    ],
    details: [
      {
        id: "7",
        organization: "Next Gen",
        cohort: "Cohort H",
        team: "Team Theta",
        role: "UI/UX Designer",
      },
    ],
  },
  {
    id: "6",
    organization: "Beta Enterprises",
    cohort: "Cohort D",
    team: "Team Delta",
    role: "Analyst",
    license: [
      {
        product: "Software A",
        start: "2023-02-01",
        expiration: "2024-02-01",
        invoice: "INV-007",
        status: "Active",
      },
    ],
    details: [
      {
        id: "8",
        organization: "Beta Enterprises",
        cohort: "Cohort D",
        team: "Team Delta",
        role: "Analyst",
      },
    ],
  },
  {
    id: "7",
    organization: "Tech Pioneers",
    cohort: "Cohort F",
    team: "Team Zeta",
    role: "Software Engineer",
    license: [
      {
        product: "Software B",
        start: "2023-05-15",
        expiration: "2024-05-15",
        invoice: "INV-008",
        status: "Pending",
      },
    ],
    details: [
      {
        id: "9",
        organization: "Tech Pioneers",
        cohort: "Cohort F",
        team: "Team Zeta",
        role: "Software Engineer",
      },
    ],
  },
  {
    id: "8",
    organization: "Delta Solutions",
    cohort: "Cohort G",
    team: "Team Eta",
    role: "Sales Manager",
    license: [
      {
        product: "Software C",
        start: "2024-01-01",
        expiration: "2025-01-01",
        invoice: "INV-009",
        status: "Pending",
      },
    ],
    details: [
      {
        id: "10",
        organization: "Delta Solutions",
        cohort: "Cohort G",
        team: "Team Eta",
        role: "Sales Manager",
      },
    ],
  },
  {
    id: "9",
    organization: "Global Technologies",
    cohort: "Cohort I",
    team: "Team Iota",
    role: "DevOps Engineer",
    license: [
      {
        product: "Software D",
        start: "2023-04-20",
        expiration: "2024-04-20",
        invoice: "INV-010",
        status: "Active",
      },
    ],
    details: [
      {
        id: "11",
        organization: "Global Technologies",
        cohort: "Cohort I",
        team: "Team Iota",
        role: "DevOps Engineer",
      },
    ],
  },
  {
    id: "10",
    organization: "Omni Enterprises",
    cohort: "Cohort J",
    team: "Team Kappa",
    role: "QA Engineer",
    license: [
      {
        product: "Software F",
        start: "2023-09-10",
        expiration: "2024-09-10",
        invoice: "INV-011",
        status: "Active",
      },
    ],
    details: [
      {
        id: "12",
        organization: "Omni Enterprises",
        cohort: "Cohort J",
        team: "Team Kappa",
        role: "QA Engineer",
      },
    ],
  },
];

export const inviteUsers = [
  {
    name: "John Doe",
    email: "john.doe@example.com",
    team: "abc",
    role: "abc",
    product: "abc",
    validation: "Valid",
    orgAccount: "12345",
    license: "License A",
    expiration: "2025-12-31",
    invoiceNo: "INV001",
  },
  {
    name: "Jane Smith",
    email: "jane.smith@example.com",
    team: "sad",
    role: "sad",
    product: "sad",
    validation: "Pending",
    orgAccount: "67890",
    license: "License B",
    expiration: "2024-11-30",
    invoiceNo: "INV002",
  },
  {
    name: "Alice Johnson",
    email: "alice.johnson@example.com",
    team: "abc",
    role: "abc",
    product: "sad",
    validation: "Valid",
    orgAccount: "23456",
    license: "License A",
    expiration: "2025-10-29",
    invoiceNo: "INV003",
  },
  {
    name: "Bob Lee",
    email: "bob.lee@example.com",
    team: "sad",
    role: "abc",
    product: "abc",
    validation: "Invalid",
    orgAccount: "98765",
    license: "License C",
    expiration: "2023-09-30",
    invoiceNo: "INV004",
  },
  {
    name: "Charlie Brown",
    email: "charlie.brown@example.com",
    team: "abc",
    role: "sad",
    product: "abc",
    validation: "Valid",
    orgAccount: "54321",
    license: "License B",
    expiration: "2025-01-01",
    invoiceNo: "INV005",
  },
  {
    name: "David Miller",
    email: "david.miller@example.com",
    team: "sad",
    role: "sad",
    product: "sad",
    validation: "Pending",
    orgAccount: "11223",
    license: "License A",
    expiration: "2024-03-22",
    invoiceNo: "INV006",
  },
  {
    name: "Emily Davis",
    email: "emily.davis@example.com",
    team: "abc",
    role: "abc",
    product: "sad",
    validation: "Invalid",
    orgAccount: "44556",
    license: "License C",
    expiration: "2023-07-15",
    invoiceNo: "INV007",
  },
  {
    name: "Frank Wilson",
    email: "frank.wilson@example.com",
    team: "sad",
    role: "abc",
    product: "abc",
    validation: "Valid",
    orgAccount: "77889",
    license: "License B",
    expiration: "2026-05-09",
    invoiceNo: "INV008",
  },
  {
    name: "Grace Taylor",
    email: "grace.taylor@example.com",
    team: "abc",
    role: "sad",
    product: "sad",
    validation: "Pending",
    orgAccount: "99001",
    license: "License A",
    expiration: "2024-08-12",
    invoiceNo: "INV009",
  },
  {
    name: "Henry Evans",
    email: "henry.evans@example.com",
    team: "sad",
    role: "sad",
    product: "abc",
    validation: "Valid",
    orgAccount: "22334",
    license: "License C",
    expiration: "2025-02-20",
    invoiceNo: "INV010",
  }
];
